module.exports = __webpack_public_path__ + "7a0688fce766ff2542221d823792e4b6.png";